export const Roles = {
  MEMBER: 'member',
  MANAGER: 'manager',
  ADMIN: 'admin'
}
